import AdminListManagementChoiceList from "@pages/Admin/ListMangement/ChoiceList";

export const AdminListManagementRoutes = [
  {
    path: "/admin/list-management/choice-list",
    name: "admin_list_management_choice_list",
    component: AdminListManagementChoiceList,
  },
];
